import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton, TextButtonClassNames } from '../../../../commons/buttons/TextButton';
import { ReactComponent as ChangeService } from '../../../../../assets/images/services/ChangeService.svg';
import { ReactComponent as StopService } from '../../../../../assets/images/services/StopService.svg';
import { ReactComponent as RestoreService } from '../../../../../assets/images/services/RestoreService.svg';
import { ReactComponent as ManageService } from '../../../../../assets/images/services/ManageService.svg';
import { AccountTypes } from '../../../../../models/Common';

interface ServiceFooterProps {
  id: number;
  accountType: AccountTypes | '';
  handleChange: (id: number, accountType: AccountTypes | '') => void;
  handleRestore: () => void;
  handleSuspense: () => void;
  handleManage: () => void;
  isPauseAvailable: boolean;
  isRestoreAvailable: boolean;
  isServiceChangingAvailable: boolean;
}

const ServiceFooter: FC<ServiceFooterProps> = ({
  id,
  accountType,
  handleChange,
  handleSuspense,
  handleRestore,
  handleManage,
  isPauseAvailable,
  isRestoreAvailable,
  isServiceChangingAvailable,
}) => {
  const { t } = useTranslation();
  const isAvailable = isServiceChangingAvailable || isPauseAvailable || isRestoreAvailable || accountType !== 'ctv';

  if (!isAvailable) return null;

  return (
    <div className="service-card__footer__content">
      {isServiceChangingAvailable ? (
        <TextButton
          label={t('buttons.change')}
          handleClick={() => handleChange(id, accountType)}
          beforeIcon={<ChangeService />}
          className={TextButtonClassNames.Default}
        />
      ) : null}
      {isPauseAvailable ? (
        <TextButton
          label={t('buttons.pause')}
          handleClick={handleSuspense}
          beforeIcon={<StopService />}
          className={TextButtonClassNames.Default}
        />
      ) : null}
      {isRestoreAvailable ? (
        <TextButton
          label={t('buttons.restore')}
          handleClick={handleRestore}
          beforeIcon={<RestoreService />}
          className={TextButtonClassNames.Accent}
        />
      ) : null}
      {accountType !== 'ctv' ? (
        <TextButton
          label={t('buttons.settings')}
          handleClick={handleManage}
          beforeIcon={<ManageService />}
          className={TextButtonClassNames.Default}
        />
      ) : null}
    </div>
  );
};

export default ServiceFooter;
